import React from "react";

const Pulse: React.FC<{ className: string }> = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 ${className}`} />
);

const MobileDashboardSkeleton: React.FC = () => (
  <div className="h-full overflow-hidden bg-gray-50 px-4 pt-[calc(env(safe-area-inset-top)_+_1.25rem)]">
    <div className="flex items-center justify-between">
      <div className="space-y-2">
        <Pulse className="h-3 w-28 rounded-full" />
        <Pulse className="h-6 w-44 rounded-lg" />
      </div>
      <Pulse className="h-11 w-11 rounded-2xl" />
    </div>
    <Pulse className="mt-6 h-44 w-full rounded-3xl" />
    <div className="mt-6 grid grid-cols-4 gap-2">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="flex flex-col items-center gap-2">
          <Pulse className="h-14 w-14 rounded-2xl" />
          <Pulse className="h-2.5 w-12 rounded-full" />
        </div>
      ))}
    </div>
    <Pulse className="mt-8 h-4 w-24 rounded-full" />
    <div className="mt-3 grid grid-cols-3 gap-2.5">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <Pulse key={i} className="h-24 rounded-2xl" />
      ))}
    </div>
  </div>
);

export default MobileDashboardSkeleton;
